<template>
    <div class="mt20 step-two-wrapper">
        <div class="one-title">问题需求</div>
        <avue-form ref="form" v-model="orderForm" :option="orderOption" @submit="handleSubmit" @error="error">
            <template slot="menuForm" v-if="!isDetail">
                <el-button type="primary" size="mini" @click="goNextHandle(0)">上一步</el-button>
                <el-button type="primary" size="mini" @click="goNextHandle(2)">下一步</el-button>
            </template>
        </avue-form>
        <div class="mt10 tac" v-if="isDetail">
            <el-button type="primary" size="mini" @click="goNextHandle(0)">上一步</el-button>
            <el-button type="primary" size="mini" @click="goNextHandle(2)">下一步</el-button>
        </div>
    </div>
</template>
<script>
import { add, update } from "@/api/archives/index";
import { makeBucket } from "@/api/resource/oss"
export default {
    props: {
        data: {
            type: Object,
            default: {}
        },
        isDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            text: [],
            orderForm: {},
            orderOption: {
                size: 'mini',
                detail: this.isDetail,
                emptyBtn: false,
                submitText: '保存',
                labelWidth: 120,
                group: [{
                    label: '问题需求',
                    prop: 'baseInfo',
                    labelWidth: 200,
                    column: [{
                            label: '1、健康问题',
                            prop: "healthProblems",
                            bind: 'basisArchiveProblem.healthProblems',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'healthy'
                            },
                            dataType: 'number',
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,

                        }, {
                            // labelWidth: 0,
                            prop: 'healthProblemsRemark',
                            bind: 'basisArchiveProblem.healthProblemsRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '2、情绪问题',
                            prop: 'emotionalProblems',
                            bind: 'basisArchiveProblem.emotionalProblems',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'emotional'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true

                        }, {
                            // labelWidth: 0,
                            prop: 'emotionalProblemsRemark',
                            bind: 'basisArchiveProblem.emotionalProblemsRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '3、家庭暴力',
                            prop: 'domesticViolence',
                            bind: 'basisArchiveProblem.domesticViolence',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'family_violence'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        }, {
                            // labelWidth: 0,
                            prop: 'domesticViolenceRemark',
                            bind: 'basisArchiveProblem.domesticViolenceRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '4、外宿居住需求',
                            prop: 'housingArrangement',
                            bind: 'basisArchiveProblem.housingArrangement',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'housing_situation'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        }, {
                            // labelWidth: 0,
                            prop: 'housingArrangementRemark',
                            bind: 'basisArchiveProblem.housingArrangementRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '5、家庭照料情况',
                            prop: 'employmentService',
                            bind: 'basisArchiveProblem.employmentService',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'employment_service'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        }, {
                            // labelWidth: 0,
                            prop: 'employmentServiceRemark',
                            bind: 'basisArchiveProblem.employmentServiceRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '7、政策咨询',
                            prop: 'policyConsultation',
                            bind: 'basisArchiveProblem.policyConsultation',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        }, {
                            // labelWidth: 0,
                            prop: 'policyConsultationRemark',
                            bind: 'basisArchiveProblem.policyConsultationRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '8、是否司法矫正、安置帮教',
                            prop: 'judicialPlacement',
                            bind: 'basisArchiveProblem.judicialPlacement',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,

                        }, {
                            // labelWidth: 0,
                            prop: 'judicialPlacementRemark',
                            bind: 'basisArchiveProblem.judicialPlacementRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '9、不良嗜好',
                            prop: 'badAddiction',
                            bind: 'basisArchiveProblem.badAddiction',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'bad_hobby'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        }, {
                            // labelWidth: 0,
                            prop: 'badAddictionRemark',
                            bind: 'basisArchiveProblem.badAddictionRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },{
                            label: "10、是否有纹身",
                            prop: "tattoo",
                            bind: 'basisArchiveProblem.tattoo',
                            type: "radio",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'there_tattoo'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        },{
                            // labelWidth: 0,
                            prop: 'tattooRemark',
                            bind: 'basisArchiveProblem.tattooRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, 
                        // {
                        //     label: "11、是否有手淫行为",
                        //     prop: "isMasturbation",
                        //     bind: 'basisArchiveProblem.isMasturbation',
                        //     type: "checkbox",
                        //     dicUrl: "/api/blade-system/dict-biz/dictionary",
                        //     dataType: "number",
                        //     dicQuery: {
                        //         code: 'Masturbation'
                        //     },
                        //     props: {
                        //         label: "dictValue",
                        //         value: "dictKey"
                        //     },
                        //     row: true,
                        //     span: 24,
                        // }, {
                        //     label: "12、是否有观看淫秽视频行为",
                        //     prop: "isVideo",
                        //     bind: 'basisArchiveProblem.isVideo',
                        //     type: "checkbox",
                        //     dicUrl: "/api/blade-system/dict-biz/dictionary",
                        //     dicQuery: {
                        //         code: 'Obscene_video'
                        //     },
                        //     props: {
                        //         label: "dictValue",
                        //         value: "dictKey"
                        //     },
                        //     row: true,
                        //     span: 24,
                        // }, 
                        {
                            label: "11、是否有打架经历",
                            prop: "fightExperience",
                            bind: 'basisArchiveProblem.fightExperience',
                            type: "radio",
                            dataType: "number",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Fighting_experience'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        }, {
                            // labelWidth: 0,
                            prop: 'fightExperienceRemark',
                            bind: 'basisArchiveProblem.fightExperienceRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: "12、是否经常出入娱乐场所",
                            prop: "entertainmentVenues",
                            bind: 'basisArchiveProblem.entertainmentVenues',
                            type: "radio",
                            dataType: "number",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Entertainment_place'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        },  {
                            // labelWidth: 0,
                            prop: 'entertainmentVenuesRemark',
                            bind: 'basisArchiveProblem.entertainmentVenuesRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },{
                            label: "13、是否夜不归宿行为",
                            dataType: "number",
                            prop: "nightOut",
                            bind: 'basisArchiveProblem.nightOut',
                            type: "radio",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Nocturnal_behavior'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        }, {
                            // labelWidth: 0,
                            prop: 'nightOutRemark',
                            bind: 'basisArchiveProblem.nightOutRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: "14、作息时间",
                            prop: "workTime",
                            dataType: "number",
                            bind: 'basisArchiveProblem.workTime',
                            type: "checkbox",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Time_Table'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        }, {
                            // labelWidth: 0,
                            prop: 'workTimeRemark',
                            bind: 'basisArchiveProblem.workTimeRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: "15、是否有犯罪前科",
                            dataType: "criminalRecord",
                            prop: "rangeType8",
                            bind: 'basisArchiveProblem.criminalRecord',
                            type: "radio",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Criminal_record'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        },  {
                            // labelWidth: 0,
                            prop: 'criminalRecordRemark',
                            bind: 'basisArchiveProblem.criminalRecordRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },{
                            label: "16、是否喜欢网络游戏",
                            dataType: "number",
                            prop: "isOnlineGame",
                            bind: 'basisArchiveProblem.isOnlineGame',
                            type: "radio",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'network_game'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        },  {
                            // labelWidth: 0,
                            prop: 'isOnlineGameRemark',
                            bind: 'basisArchiveProblem.isOnlineGameRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: "17、在校处分情况",
                            dataType: "number",
                            prop: "isDisciplinary",
                            bind: 'basisArchiveProblem.isDisciplinary',
                            type: "checkbox",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'punishment'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        },  {
                            // labelWidth: 0,
                            prop: 'isDisciplinaryRemark',
                            bind: 'basisArchiveProblem.isDisciplinaryRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },{
                            label: "18、是否有旷课行为",
                            dataType: "number",
                            prop: "isTruancy",
                            bind: 'basisArchiveProblem.isTruancy',
                            type: "radio",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Absenteeism'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        }, {
                            // labelWidth: 0,
                            prop: 'isTruancyRemark',
                            bind: 'basisArchiveProblem.isTruancyRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },{
                            label: "19、法律法规认知程度",
                            dataType: "number",
                            prop: "isRegulations",
                            bind: 'basisArchiveProblem.isRegulations',
                            type: "checkbox",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Awareness-laws_regulations'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                        }, {
                            // labelWidth: 0,
                            prop: 'isRegulationsRemark',
                            bind: 'basisArchiveProblem.isRegulationsRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '20、院舍庇护需求',
                            prop: 'arranging',
                            bind: 'basisArchiveProblem.arranging',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            formslot: true,
                            span: 24,
                        }, {
                            prop: 'arrangingRemark',
                            bind: 'basisArchiveProblem.arrangingRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12
                        },
                        {
                            label: '21、行为问题',
                            prop: 'behaviorProblems',
                            bind: 'basisArchiveProblem.behaviorProblems',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,

                        }, {
                            // labelWidth: 0,
                            bind: 'basisArchiveProblem.behaviorProblemsRemark',
                            placeholder:'请输入其他',
                            prop: 'behaviorProblemsRemark',
                            row: true,
                            span: 12,

                        },
                        {
                            label: '22、儿童照顾',
                            prop: 'childCare',
                            bind: 'basisArchiveProblem.childCare',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,
                        }, {
                            // labelWidth: 0,
                            prop: 'childCareRemark',
                            bind: 'basisArchiveProblem.childCareRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },
                        {
                            label: '23、学习问题',
                            prop: 'learningProblems',
                            bind: 'basisArchiveProblem.learningProblems',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true
                        }, {
                            // llabelWidth: 0,
                            prop: 'learningProblemsRemark',
                            bind: 'basisArchiveProblem.learningProblemsRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },
                        {
                            label: '24、婚恋问题',
                            prop: 'marriageProblems',
                            bind: 'basisArchiveProblem.marriageProblems',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,
                        }, {
                            // labelWidth: 0,
                            prop: 'marriageProblemsRemark',
                            bind: 'basisArchiveProblem.marriageProblemsRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },
                        {
                            label: '25、经济援助',
                            prop: 'financialAid',
                            bind: 'basisArchiveProblem.financialAid',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,
                        }, {
                            // labelWidth: 0,
                            prop: 'financialAidRemark',
                            bind: 'basisArchiveProblem.financialAidRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        },
                        {
                            label: '26、其他',
                            labelWidth: 90,
                            prop: 'other',
                            bind: 'basisArchiveProblem.other',
                            type: "radio",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'yes_no'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,
                        }, {
                            labelWidth: 90,
                            prop: 'otherRemark',
                            bind: 'basisArchiveProblem.otherRemark',
                            placeholder:'请输入其他',
                            row: true,
                            span: 12,

                        }, {
                            label: '27、颜色标注',
                            labelWidth: 90,
                            prop: 'classification',
                            bind: 'basisArchiveProblem.classification',
                            type: "checkbox",
                            dicUrl: '/api/blade-system/dict-biz/dictionary',
                            dicQuery: {
                                code: 'Color'
                            },
                            dataType: "number",
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            row: true,
                            span: 24,
                            formslot: true,
                        },
                        {
                            label: "2.1主动需求/问题摘要",
                            labelPosition: "top",
                            prop: "problemSummary",
                            bind: 'basisArchiveProblem.problemSummary',
                            type: "textarea",
                            row: true,
                            span: 24,
                        }
                    ]
                }]
            },
        }
    },
    watch: {
        data: {
            deep: true,
            handler(val) {
                this.orderForm = this.data
            }
        }
    },
    mounted() {
        this.orderForm = this.data
    },
    methods: {
        goNextHandle(num) {
            this.$emit("next", num)
        },
        handleSubmit(form, done, loading) {
            update(this.orderForm).then((res) => {
                // 获取新增数据的相关字段
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                // 数据回调进行刷新
                this.$refs.form.resetForm();
                done();
                this.$emit("refresh", res.data.data.id || '')
            }, error => {
                done();
                window.console.log(error);
            });
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style lang="scss">
.step-two-wrapper {
    .one-title {
        padding: 30px 0;
        font-size: 20px;
        text-align: center;
    }

    .el-form-item--small.el-form-item {
        margin-bottom: 0
    }
}

</style>
